export default "__VITE_ASSET__8NIK3DgG__"